import { useIsMobile } from "@/hooks/use-mobile";

const AnimatedBackground = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" aria-hidden="true">
        <div
          className="absolute -top-20 -left-20 w-[70vw] h-[70vw] rounded-full blur-3xl animate-gentle-float will-change-transform"
          style={{ background: "radial-gradient(circle, hsla(0,43%,90%,0.45) 0%, transparent 70%)" }}
        />
        <div
          className="absolute bottom-10 -right-10 w-[60vw] h-[60vw] rounded-full blur-3xl animate-drift will-change-transform"
          style={{ background: "radial-gradient(circle, hsla(20,60%,87%,0.4) 0%, transparent 70%)" }}
        />
        <div
          className="absolute top-1/2 left-1/4 w-[50vw] h-[50vw] rounded-full blur-3xl animate-pulse-soft will-change-transform"
          style={{ background: "radial-gradient(circle, hsla(310,25%,87%,0.35) 0%, transparent 70%)" }}
        />
      </div>
    );
  }

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" aria-hidden="true">
      {/* Large Rosé blob - top left */}
      <div
        className="absolute -top-32 -left-32 w-[700px] h-[700px] rounded-full blur-[100px] animate-gentle-float will-change-transform"
        style={{ background: "radial-gradient(circle, hsla(0,43%,90%,0.5) 0%, hsla(0,43%,90%,0.2) 40%, transparent 70%)" }}
      />

      {/* Peach blob - top right */}
      <div
        className="absolute -top-20 right-0 w-[600px] h-[600px] rounded-full blur-[90px] animate-drift will-change-transform"
        style={{ background: "radial-gradient(circle, hsla(20,60%,87%,0.45) 0%, hsla(20,50%,85%,0.15) 45%, transparent 70%)" }}
      />

      {/* Lavender blob - center */}
      <div
        className="absolute top-1/3 left-1/3 w-[650px] h-[650px] rounded-full blur-[110px] animate-pulse-soft will-change-transform"
        style={{ background: "radial-gradient(circle, hsla(310,25%,87%,0.45) 0%, hsla(310,20%,85%,0.15) 45%, transparent 70%)" }}
      />

      {/* Creme blob - bottom */}
      <div
        className="absolute bottom-0 left-1/4 w-[700px] h-[700px] rounded-full blur-[100px] animate-gentle-float will-change-transform"
        style={{ background: "radial-gradient(circle, hsla(30,30%,93%,0.5) 0%, hsla(30,25%,90%,0.2) 40%, transparent 70%)", animationDelay: "5s" }}
      />

      {/* Extra Rosé accent - bottom right */}
      <div
        className="absolute bottom-1/4 right-10 w-[500px] h-[500px] rounded-full blur-[80px] animate-drift will-change-transform"
        style={{ background: "radial-gradient(circle, hsla(0,40%,88%,0.4) 0%, transparent 65%)", animationDelay: "10s", animationDirection: "reverse" }}
      />

      {/* Subtle shimmer line */}
      <div className="absolute top-1/2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent animate-shimmer-slow" />
    </div>
  );
};

export default AnimatedBackground;
